import { AppService } from 'src/app/app.service';
import { Injectable } from '@angular/core';
import { DirectusService } from './directus.service';
import { ILoginCredentials } from '@directus/sdk-js/dist/types/schemes/auth/Login';
import { databaseSettings } from 'src/environments/database-settings';
import { Storage } from '@ionic/storage-angular';
import { SideMenuService } from './side-menu.service';
import { AppDataService } from './app-data.service';
import { NavigationExtras, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { PushNotificationService } from './push-notifications.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { rejects } from 'assert';
import { type } from 'os';
import { resolve } from 'path';
import { ErrorModalService } from './error-modal.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  isLoggedIn = false;
  externalSiteData = null;
  creds;
  navigationExtras: NavigationExtras = {};
  constructor(
    private directusService: DirectusService,
    private storage: Storage,
    private menuService: SideMenuService,
    private dataService: AppDataService,
    private router: Router,
    private pushNotificationService: PushNotificationService,
    private http: HttpClient,
    private errorModal: ErrorModalService,
  ) {
    this.getExternalSite().then(externalConfig => {
      if (externalConfig.length) {
        this.externalSiteData = externalConfig[0];
      }
    });
  }

  ngOnInit() {
    // console.log('Authentication services:');
  }

  getExternalSite(): Promise<any> {
    return new Promise((resolve) => {
      this.directusService.api.getItems('external_site_configs').then(res => {
        return resolve([...res.data]);
      }).catch(e => {
        return resolve([]);
      })
    })
  }
  login(email, password) {
    let params = {
      username: email,
      password: password
    }
    return this.directusService.api.api.post(this.dataService.ApiPath + 'api/MobileLogin', params).then(async user => {
      console.log(user)
      if (user?.success) {
        this.isLoggedIn = true;
        await this.storage.set('creds', { email, password });
        await this.storage.set('userId', user.rows[0].id);
        await this.storage.set('userType', user.rows[0].profile);
        await this.storage.set('userIme', user.rows[0].ime);
        await this.storage.set('userToken', user.token);
        this.menuService.initSideMenu()
        this.initPushNotification();
        this.dataService.dismissLoader();
        if (user.rows[0].profile == "Driver") {
          this.router.navigate(['my-courses']);
        } else {
          this.router.navigate(['orders']);
        }
      } else {
        this.dataService.dismissLoader();
        this.errorModal.httpError('custom', user.message);
        this.router.navigate(['/login'])
      }
    }).catch(err => {
      // console.log(err)
      this.dataService.dismissLoader();
      this.errorModal.httpError('custom', err.message);
      this.router.navigate(['/login'])
    });
  }
  createUser(data) {
    return this.directusService.api.api.post('users', data);
  }

  updateUser(id, data: FormData | any) {
    return this.directusService.api.api.patch('users/' + id, data);
  }

  loginNewUser(email, password) {
    const data: ILoginCredentials = {
      url: databaseSettings.directus.split('/').slice(0, -1).join('/'),
      project: databaseSettings.directus.split('/').pop(),
      email,
      password,
      persist: true,
    };

    this.isLoggedIn = true;
    this.storage.set('creds', { email, password });
    this.loginExternalSite(email, password);
    return this.directusService.api.login(data);
  }

  resetUserPassword(email) {
    this.dataService.presentLoader({
      message: 'Requesting...',
    });
    return this.directusService.api.requestPasswordReset(email);
  }

  resetPassword(password, token) {
    this.dataService.presentLoader({
      message: 'Loading...',
    });
    return this.directusService.api.resetPassword(password, token);
  }

  logoutUser() {
    try {
      this.isLoggedIn = false;
      this.storage.clear();
      this.router.navigate(['/login'], { replaceUrl: true });
      // this.initPushNotification();
    } catch (err) {
      // console.log(err)
      return
    }
  }

  async getLocalStorage() {

    this.creds = await this.storage.get('creds');
    if (this.creds) {
      this.login(this.creds.email, this.creds.password)
        .then(() => {
          this.dataService.dismissLoader();
        })
        .catch((error) => {
          this.dataService.dismissLoader();
        });
    } else {
      this.dataService.dismissLoader();
      this.router.navigate(['login'])
      // this.router.navigate([`${this.menuService.homePageUrl}`], {
      //   replaceUrl: true,
      // });
    }
  }

  initPushNotification() {
    // console.log('initPushNotification 0');
    const isPushNotificationAvailable = Capacitor.isPluginAvailable(
      'PushNotifications'
    );
    // console.log('Is Push Notification Avaialble', isPushNotificationAvailable);
    if (isPushNotificationAvailable) {
      this.pushNotificationService.initPushNotification('');
    }
  }

  loginExternalSite(email, password) {
    return new Promise((resolve, reject) => {
      this.getExternalSite().then(externalConfig => {
        if (externalConfig.length) {
          externalConfig = externalConfig[0];
          const externalUrl = externalConfig.login_url;
          if (externalUrl) {
            let formData: FormData = new FormData();
            formData.append('username', email);
            formData.append('password', password);
            this.http.post(`${externalUrl}`, formData).subscribe(response => {
              if (typeof response != "undefined") {
                this.storage.get('userData').then(userData => {
                  if (typeof userData != "undefined") {
                    Object.assign(userData, { external_user_data: response });
                    this.storage.set('userData', userData);
                  }
                  resolve(response);
                });
              } else {
                resolve(response);
              }
            }, (e) => {
              resolve(e);
            });
          } else {
            resolve(true);
          }
        }
      }).catch(e => {
        resolve(false);
      });
    });
  }

  async getUserData() {
    return await this.storage.get('userData');
  }

  updateExternalSite(name) {
    return new Promise((resolve, reject) => {
      this.getExternalSite().then(externalConfig => {
        // console.log('externalConfig:', externalConfig);
        if (externalConfig.length) {
          externalConfig = externalConfig[0];
          this.getUserData().then(userData => {
            // console.log('userData:', userData);
            if (userData && typeof userData.external_user_data != "undefined") {
              const externalUserData = userData.external_user_data;
              const externalUserToken = externalUserData.token;
              const externalUrl = externalConfig.update_user_url;
              if (externalUrl) {
                const data = {
                  user_name_register: name,
                  user_id: externalUserData.user_id
                }
                const httpOptions = {
                  headers: new HttpHeaders({
                    Authorization: "Bearer " + externalUserToken
                  })
                };
                this.http.post(`${externalUrl}`, data, httpOptions).subscribe(response => {
                  let data: any = response;
                  if (typeof data != "undefined" && typeof data.status != "undefined" && data.status == 1) {
                    Object.assign(externalUserData, { user_display_name: name });
                    Object.assign(userData, { external_user_data: externalUserData });
                    this.storage.set('userData', userData);
                  }
                  resolve(data);
                });
              }
            } else {
              resolve(false);
            }
          });
        }
      });
    });
  }
}
